var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isLoading)?_c('v-progress-circular',{attrs:{"color":_vm.color,"size":_vm.loadingSpinnerSize,"indeterminate":""}}):_vm._e(),(_vm.count)?_c('span',[_vm._v(" "+_vm._s(_vm._f("millify")(_vm.count))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }